/* eslint-disable quotes */
// 最大14位正数且 保留2位小数
export const positiveThirteenAndSix = /^-?(\d{1,13})(\.\d{1,2})?$/;
// 负数、整数、小数
export const positiveNumber = /^-?\d+(\.\d+)?$/;
// 负数、0、正数
export const isNumber = /^-?(0|[1-9]\d*)$/;
// 大于0，不包含0
export const greaterThanZore = /^(?!0*(\.0+)?$)\d+(\.\d+)?$/;
// 小于0，不包含0
export const lessThanZore = /^-[1-9]\d*(\.\d+)?$|^-0\.\d*[1-9]\d*$/;
// 数字
export const allNumber = /^-?(0|([1-9]\d*))(\.\d+)?$/;
// 数字-大于等于0
export const greaterZore = /^(0|[1-9]\d*)(\.\d+)?$|^0\.\d+$/;
// 常用URL格式
export const urlReg = /^(https?:\/\/)([a-zA-Z0-9-]+\.)*[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9]\.[a-zA-Z]{2,}(:[0-9]{1,5})?(\/[^\s]*)?(\?[^\s]*)?$/;
// 身份证
export const idNumber = /(^\d{15}$)|(^\d{18}$)|(^\d{17}[\dXx]$)/;
// email
export const email = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
// 邮编
export const ebcuZipCOde = /[1-9]\d{5}(?!\d)/;
// 手机
export const phoneReg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
// 英文 英文符号 空格
export const noChineseReg = /^[A-Za-z\s\.\,\!\?\;\:\'\"\`\~@#\$%\^&\*\(\)_\-\+=\[\]\{\}\|\\\/<>]*$/;
// 数字 () -
export const telephoneReg = /^[0-9()\-]+$/;
// 数字 %
export const numberPercent = /^-?(0|([1-9]\d*))(\.\d+)?%?$/;
// 不能包含空格
export const noSpaceReg = /^\S*$/;

/* eslint-disable quotes */
